import React from 'react';
import { connect } from 'react-redux';

import LinkTypeEnum from 'redpoints-model-js/enumeration/LinkTypeEnum';

import { Progress } from 'redpoints-front-components/index';

import {
  getLinksManagementLinksProcessedContentLinks,
  getLinksManagementLinksProcessedDetectionLinks,
  getLinksManagementLinksProcessingContentLinks,
  getLinksManagementLinksProcessingDetectionLinks,
} from '../../../reducers/tasks/linksManagement';

import './linksManagement.less';

const getPercent = (processed, total) => {
  const percent = Math.round((processed * 100) / total);
  return isNaN(percent) ? 1 : percent;
};

const LinksManagementViewerLinkListCounter = ({
  contentLinks,
  contentLinksProcessed,
  detectionLinks,
  detectionLinksProcessed,
  linkType,
}) => {
  let links = [];
  let processed = 0;
  if (linkType === LinkTypeEnum.DETECTION) {
    links = detectionLinks;
    processed = detectionLinksProcessed;
  }
  if (linkType === LinkTypeEnum.CONTENT) {
    links = contentLinks;
    processed = contentLinksProcessed;
  }

  const isValidCurrentIndex = Boolean(links.length);

  return (
    <div className="rp-links-management-counter">
      {isValidCurrentIndex && (
        <Progress
          percent={getPercent(processed, links.length)}
          format={() => `${processed} / ${links.length}`}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    detectionLinks: getLinksManagementLinksProcessingDetectionLinks(state),
    detectionLinksProcessed: getLinksManagementLinksProcessedDetectionLinks(
      state
    ),
    contentLinks: getLinksManagementLinksProcessingContentLinks(state),
    contentLinksProcessed: getLinksManagementLinksProcessedContentLinks(state),
  };
};

export default connect(
  mapStateToProps,
  null
)(LinksManagementViewerLinkListCounter);
